import React, { memo } from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';

export const PrimaryAgendaButton = memo(
  ({ item, label, isEditMode = false }) => {
    if (!item) return null;
    const icon = item.icon || 'fa-solid fa-calendar';
    return (
      <div className="text-center">
        <ConditionalLink
          condition={!isEditMode}
          href={item.href}
          className="br-button small primary-outline d-inline-flex align-items-center gap-1"
          aria-label={label}
        >
          <MaybeWrap
            as={'button'}
            condition={isEditMode}
            className="br-button small primary-outline d-inline-flex align-items-center gap-1 disabled"
          >
            <span className={icon} aria-hidden="true" />
            <span>{label}</span>
          </MaybeWrap>
        </ConditionalLink>
      </div>
    );
  },
);
